<div class="max-width-p">
  <app-notification-banner></app-notification-banner>
  <benefit-header-summary [headerText]="'HISTORY.HEADER_TITLE1' | translate"
                          [smallText]="'HISTORY.HEADER_TITLE2' | translate"
                          [showBudgetCard]="false">
  </benefit-header-summary>

  <div class="sorting-card" *ngIf="isFlexPlan">
    <div class="left d-flex w-100">
      <ul class="w-100">
        <li [ngClass]="{ active: !selectedBenefitType }" (click)="selectBenefitType(0)">
          {{ 'HISTORY.FILTER.ALL' | translate }}
        </li>
        <li class="border-left-0" [ngClass]="{
            active: selectedBenefitType === subscriptionBenefitType
          }" (click)="selectBenefitType(2)" >
          {{ 'HISTORY.FILTER.SUBSCRIPTION' | translate }}
        </li>
        <li class="border-left-0" *ngIf="hasExpenseReports" [ngClass]="{
            active: selectedBenefitType === expenseReportType
          }" (click)="selectBenefitType(3)" >
          {{ 'HISTORY.FILTER.EXPENSE_REPORTS' | translate }}
        </li>
        <li class="border-left-0" *ngIf="hasInsuranceOrders" [ngClass]="{
            active: selectedBenefitType === insuranceType
          }" (click)="selectBenefitType(4)">
          {{ 'HISTORY.FILTER.INSURANCE' | translate }}
        </li>
      </ul>
    </div>
  </div>

  <div class="earnings-card" *ngIf="selectedBenefitType !== expenseReportType && selectedBenefitType !== insuranceType">
    <div class="accepted-order-wrapper" *ngIf="(status === 'confirmed' || status === 'recurrent') && showSuccessBanner">
      <span class="icon"></span>
      {{ 'HISTORY.SUCCESS_ORDER' | translate }}
    </div>
    <div *ngIf="historyBenefits?.length === 0">
      <p class="d-flex justify-content-around">
        <a>{{ 'HISTORY.NO_ORDERS' | translate }}</a>
      </p>
    </div>
    <div *ngFor="let benefit of historyBenefits;let i=index;first as isFirst">
      <app-benefit-history-details
        [hasOrderBeenPlaced]="isFirst && status === 'confirmed'"
        [benefit]="benefit" [subdomain]="subdomain"></app-benefit-history-details>
    </div>
  </div>

  <div class="earnings-card" *ngIf="selectedBenefitType === expenseReportType">
    <div *ngIf="expenseReports?.length === 0">
      <p class="d-flex justify-content-around">
        <a>{{ 'HISTORY.NO_EXPENSE_REPORTS' | translate }}</a>
      </p>
    </div>
    <div *ngFor="let report of expenseReports">
      <app-expense-report-history-details
        [report]="report" [subdomain]="subdomain"></app-expense-report-history-details>
    </div>
  </div>

  <div class="earnings-card" *ngIf="selectedBenefitType === insuranceType">
    <div *ngIf="insuranceOrders?.length === 0">
      <p class="d-flex justify-content-around">
        <a>{{ 'HISTORY.NO_INSURANCE_ORDERS' | translate }}</a>
      </p>
    </div>
    <app-insurance-history-table
      *ngIf="insuranceOrders?.length > 0"
      [orders]="insuranceOrders"
      [subdomain]="subdomain">
    </app-insurance-history-table>
  </div>

  <div class="row justify-content-center">
    <button *ngIf="totalNumberOfOrders > numberOfOrdersShown && this.selectedBenefitType == 0" class="btn btn-secondary bold" (click)="loadMoreOrders()">
      {{ 'HISTORY.LOAD_MORE' | translate }}
    </button>

    <button *ngIf="(totalNumberOfSubscriptionsShown + totalNumberOfAutoOrdersShown) > (numberOfSubscriptionsShown + numberOfAutoOrdersShown) &&
    this.selectedBenefitType == subscriptionBenefitType" class="btn btn-secondary bold" (click)="loadMoreRecurrentOrders()">
      {{ 'HISTORY.LOAD_MORE' | translate }}
    </button>

    <button *ngIf="totalNumberOfExpenseReports > numberOfExpenseReportsShown &&
    this.selectedBenefitType == expenseReportType" class="btn btn-secondary bold" (click)="loadMoreExpenseReports()">
      {{ 'HISTORY.LOAD_MORE' | translate }}
    </button>
  </div>
</div>
